import React from 'react';
import { motion } from 'framer-motion';
import { V3Player } from '../../types/V3_Core';
import VintageLayout from '../layout/VintageLayout';
import { audioManager } from '../../utils/AudioManager';

interface GameOverScreenProps {
    winner?: V3Player;
    onBackToLobby: () => void;
}

const GameOverScreen: React.FC<GameOverScreenProps> = ({ winner, onBackToLobby }) => {
    React.useEffect(() => {
        // Just in case music wasn't triggered by GameApp
        audioManager.playMusic('victory');
    }, []);

    return (
        <VintageLayout>
            <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center">
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="max-w-2xl w-full bg-navy-900/90 border-4 border-gold-500 rounded-lg p-12 shadow-[0_0_50px_rgba(234,179,8,0.3)] relative overflow-hidden"
                >
                    {/* Confettis Dorés (CSS Particles) */}
                    <div className="absolute inset-0 pointer-events-none opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] animate-pulse"></div>

                    <h1 className="text-6xl font-serif text-transparent bg-clip-text bg-gradient-to-t from-gold-600 to-gold-300 mb-8 filter drop-shadow-lg">
                        VICTOIRE
                    </h1>

                    <div className="mb-12">
                        <div className="w-32 h-32 mx-auto rounded-full border-4 border-gold-400 overflow-hidden shadow-2xl mb-6 relative">
                            {/* Avatar */}
                            <div className="w-full h-full bg-slate-700 flex items-center justify-center text-4xl font-bold text-gold-500">
                                {winner?.avatarId ? winner.avatarId.substring(0, 2).toUpperCase() : "?"}
                            </div>
                        </div>

                        <h2 className="text-3xl text-cream-100 font-serif mb-2">
                            {winner?.pseudo || "Un Inconnu"}
                        </h2>
                        <p className="text-gold-500/80 uppercase tracking-widest text-sm">
                            a restauré sa mémoire
                        </p>
                    </div>

                    <div className="flex flex-col gap-4">
                        <p className="text-cream-200/60 text-sm italic mb-4">
                            "La vérité est parfois cruelle, mais elle libère toujours."
                        </p>

                        <button
                            onClick={onBackToLobby}
                            className="btn-vintage py-3 px-8 text-lg mx-auto transform hover:scale-105 transition-transform"
                        >
                            RETOUR AU QG
                        </button>
                    </div>
                </motion.div>
            </div>
        </VintageLayout>
    );
};

export default GameOverScreen;
